module.exports = __webpack_public_path__ + "components/resort-condition/static/next-significant-snowfall-b404b7b723c308cd4d9bbd950edda980.svg";